/* eslint camelcase: 0 */
/* eslint no-console: 0 */

// This file should only be included when the alert bar is on.

import { getCookie, setCookie } from './helpers/cookies';
import { parseUrl, stripSlash, noTrailingSlash } from './helpers/urls';

const setAlert = (options = {}, modifier = '') => {
  const {
    alert_is_cookied = true,
    once_per_session = false,
    cookiename = 'alertbar',
    cookievalue = 'value',
    // duration = 30, // eslint-disable-line no-unused-vars,
    page_path,
    links_to = false,
    suppression_regex = null,
  } = options;

  let sregex = false;

  if (suppression_regex) {
    try {
      sregex = new RegExp(
        suppression_regex
          .split('|')
          .map(noTrailingSlash)
          .join('|'),
      );
    } catch (e) {} // eslint-disable-line no-empty
  }

  const alertcookie_name = `${cookiename}${modifier}_clicked`;
  const seencookie_name = `${cookiename}${modifier}_seen`; // name of cookie tracking alert being seen

  const alertcookie_value = String(getCookie(alertcookie_name)); // clicked cookie value
  const seencookie_value = String(getCookie(seencookie_name));

  // does the user have a cookie and is it the right cookie
  const is_cookied = Boolean(
    alertcookie_value && alertcookie_value === String(cookievalue),
  );
  const was_seen_this_session = Boolean(
    seencookie_value && seencookie_value === String(cookievalue),
  );

  const linksTo = links_to && stripSlash(links_to);
  const pagePath = stripSlash(page_path);

  const notClickedEver = !alert_is_cookied || !is_cookied;
  const notSamePage =
    !links_to ||
    parseUrl(links_to).origin !== window.location.origin ||
    linksTo !== pagePath;
  const notBlackListPage = !sregex || !sregex.test(pagePath);
  const notSeenAlready = !once_per_session || !was_seen_this_session;
  const notClickedThisSession =
    !alert_is_cookied || !is_cookied || !was_seen_this_session;

  /*
    These conditionals are complex, but the goal is to activate the alert bar only
    as long as NONE of the below conditions are true
    */
  if (
    // if alert can be cookied but there's no matching cookie, can show
    notClickedEver &&
    // if user has not seen the alert or not clicked it closed in this session
    notClickedThisSession &&
    // if it can only be seen this session but was not seen this session, can show
    notSeenAlready &&
    // if the alert links and the page the alert links to is the page we're on, don't show
    notSamePage &&
    notBlackListPage
  ) {
    const $html = document.documentElement;
    $html.classList.add('ok-to-alert');
    $html.classList.add(`ok-to-alert__${modifier}`);
    const $alertTop = $html.querySelector('.alert-bar__top');
    // console.log('showing alert');
    // moves top alert bars up
    if ($alertTop) {
      document.body.insertBefore($alertTop, $html.querySelector('.site-wrap'));
      setTimeout(() => {
        $alertTop.classList.remove('is--initial');
        if (document.readyState !== 'loading') {
          $alertTop.classList.add('ready-to-alert');
        } else {
          document.addEventListener('DOMContentLoaded', () => {
            $alertTop.classList.add('ready-to-alert');
          });
        }
      }, 4);
    }
    // this is currently set via an X button click action in lib/alerts.js:
    // setcookie(cookiename, 1, duration)
    setCookie(seencookie_name, cookievalue || 1); // session tracking of if this alert was seen
    options.on = true;
  }

  // console.log(
  //   `modifier: ${modifier}, t/f: ${Boolean(
  //     modifier,
  //   )}, typeof(${typeof modifier})`,

  //   {
  //     alert_is_cookied,
  //     alertcookie_name,
  //     alertcookie_value: `${alertcookie_value}  ${
  //       is_cookied ? '==' : '!='
  //     } ${cookievalue}`,
  //     is_cookied,
  //     was_seen_this_session,
  //     linksTo,
  //     pagePath,
  //     sregex,
  //     conditions: {
  //       notClickedEver,
  //       notClickedThisSession,
  //       notSeenAlready,
  //       notSamePage,
  //       notBlackListPage,
  //     },
  //   },
  //   options,
  // );
};
window.setAlert = setAlert;
